var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('data-table',{ref:"segmentationList",attrs:{"model":"segmentation","endpoint":_vm.endpoint,"route-params":{ id: _vm.$route.params.id, stepid: { key: 'uuid' } },"route-context":"settings.segmentation"},on:{"action":_vm.doAction}})
}
var staticRenderFns = []

export { render, staticRenderFns }